import { render, staticRenderFns } from "./AccountRouter.vue?vue&type=template&id=7921755c&scoped=true"
import script from "./AccountRouter.vue?vue&type=script&lang=js"
export * from "./AccountRouter.vue?vue&type=script&lang=js"
import style0 from "./AccountRouter.vue?vue&type=style&index=0&id=7921755c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7921755c",
  null
  
)

export default component.exports